// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"8e804792","609":"2465104e","641":"e6b37ed0","873":"ab1b76df","989":"6ba0755c"}[chunkId] + ".chunk.js";
};